import { render, staticRenderFns } from "./booqit.vue?vue&type=template&id=0a1bf3b0&"
import script from "./booqit.vue?vue&type=script&lang=js&"
export * from "./booqit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports